import vscode from "../../assets/img/ide/vscode.webp";
import atom from "../../assets/img/ide/atom.webp";
import vscodium from "../../assets/img/ide/vscodium.webp";
import vim from "../../assets/img/ide/vim.webp";
import emacs from "../../assets/img/ide/emacs.webp";
import sublimetext from "../../assets/img/ide/sublimetext.webp";
import notepad from "../../assets/img/ide/notepad.webp";
import geany from "../../assets/img/ide/geany.webp";
import intellij from "../../assets/img/ide/intellij.webp";

export const DataIde = [
  {
    title: "VsCode",
    path: "https://code.visualstudio.com/",
    cName: "icon",
    icon: vscode,
    description:
      "As a Web Developer. I recommend using vs code, a bunch of plugins who help your career and your coding experience.",
  },
  {
    title: "Atom",
    path: "https://atom.io/",
    cName: "icon",
    icon: atom,
    description:
      "Get smarter context-aware auto-completion, code navigation features such as an outline view, go to definition and find all references. As well as hover-to-reveal information, diagnostics (errors and warnings) and document formatting.",
  },
  {
    title: "VsCodium",
    path: "https://vscodium.com/",
    cName: "icon",
    icon: vscodium,
    description:
      "Same as VsCode but without telemetry and better for privacy life, if you want it, download the 1.47 versions and install the plugins you want and after that you can upgrade it, because sometimes in the newest versions you cannot find the plugins you want.",
  },
  {
    title: "Intellij IDE",
    path: "https://www.jetbrains.com/idea/",
    cName: "icon",
    icon: intellij,
    description:
      "ENJOY PRODUCTIVE JAVA. Every aspect of IntelliJ IDEA has been designed to maximize developer productivity. Together, intelligent coding assistance and ergonomic design make development not only productive but also enjoyable.",
  },
  {
    title: "Vim",
    path: "https://www.vim.org/",
    cName: "icon",
    icon: vim,
    description:
      "Vim is a highly configurable text editor built to make creating and changing any kind of text very efficient. It is included as 'vi' with most UNIX systems and with Apple OS X. Vim is rock stable and is continuously being developed to become even better. Among its features are:persistent, multi-level undo tree extensive plugin system support for hundreds of programming languages and file formats powerful search and replace integrates with many tools",
  },
  {
    title: "Emacs",
    path: "https://www.gnu.org/software/emacs/",
    cName: "icon",
    icon: emacs,
    description: "An extensible, customizable, free/libre text editor.",
  },
  {
    title: "Sublime Text",
    path: "https://www.sublimetext.com/",
    cName: "icon",
    icon: sublimetext,
    description:
      "A sophisticated text editor for code, markup and prose. My first text editor.",
  },
  {
    title: "Notepad++",
    path: "https://notepad-plus-plus.org/",
    cName: "icon",
    icon: notepad,
    description:
      "Notepad++ is a free (as in “free speech” and also as in “free beer”) source code editor and Notepad replacement that supports several languages. ",
  },
  {
    title: "Geany",
    path: "https://www.geany.org/",
    cName: "icon",
    icon: geany,
    description:
      "Geany is a powerful, stable and lightweight programmer's text editor that provides tons of useful features without bogging down your workflow.",
  },
];
